import React from 'react';
import styled, { css } from 'styled-components/macro';
import { chatUI } from 'styles/featureColors/chatUIColors';

export const ChatUIIconButton = (props) => {
  return <Button alt={props.alt} onClick={props.onClick} src={props.src} isActive={props.isActive}></Button>;
};

const buttonWithIcon = css`
  user-select: none;
  outline: none !important;
  appearance: none;
  text-decoration: none !important;
  border: none;
  width: 26px;
  height: 26px;
  ${(props) =>
    props.isActive ? `border-bottom: 0.5px solid ${chatUI.toolbar.icons.activeBorder} ` : `0.5px solid transparent`};
  background-image: url(${(props) => props.src});
  margin-left: 16px;
  margin-bottom: 1px;
  background-color: inherit;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  :hover {
    ${(props) =>
      props.hoversrc &&
      `
      background-image: ${`url(${props.hoversrc})`};
    `};
  }
`;

const Button = styled.button`
  ${buttonWithIcon};
`;
